export enum ErrorCodes {
  RETRIEVE_PASSWORD = 'LCS1003',
  SERVICE_NOT_AVAILABLE = 'VEN1005',
  AUTHORIZATION_DENIED = 'AUTH001',
}
